import WebGalleryAlbumNullState from './WebGalleryAlbumNullState';

export default WebGalleryAlbumNullState;
